import { render, staticRenderFns } from "./PainelProjetosSein.vue?vue&type=template&id=42217978"
import script from "./PainelProjetosSein.vue?vue&type=script&lang=js"
export * from "./PainelProjetosSein.vue?vue&type=script&lang=js"
import style0 from "./PainelProjetosSein.vue?vue&type=style&index=0&id=42217978&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports